module.exports = __webpack_public_path__ + "static/media/contactIconThree.ced2be6e.webp";